import { defineMessages } from 'react-intl';

type MessageKeys = 'sourcesTitle' | 'closeSourcesPopup' | 'sourcesSidePanelTeamworkGraphTitle';

const messages: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		sourcesTitle: {
			id: 'search-ai.common.sources-popup.sourcesTitle',
			defaultMessage:
				'{numSources, plural, one {Source ({numSources, number})} other {Sources ({numSources, number})}}',
			description: 'Sources title with pluralization',
		},
		closeSourcesPopup: {
			id: 'search-ai.common.sources-popup.closeSourcesPopup',
			defaultMessage: 'Close sources popup',
			description: 'Label for the close button in the sources popup',
		},
		sourcesSidePanelTeamworkGraphTitle: {
			id: 'search-ai.common.sources-popup.sourcesSidePanelTeamworkGraphTitle',
			defaultMessage: 'Teamwork Graph',
			description: 'Teamwork graph title shown in the sources side panel',
		},
	});

export default messages;
